import { PLACE_ON_CIAN_LINK } from 'shared/constants/links';
import { NBSP } from 'shared/constants/symbols';
import type { TBanner } from 'shared/types/banner';

export type TPlaceOnCianBannerVariant = 'default' | 'host';

export const HOST_PLACE_AD_BANNER_NAME = 'CalendarBanner';

export const PLACE_ON_CIAN_BANNER_BY_VARIANT: Record<TPlaceOnCianBannerVariant, TBanner> = {
  default: {
    title: `Размещайтесь на${NBSP}Циан`,
    linkBtn: {
      url: PLACE_ON_CIAN_LINK,
      text: 'Разместить объявление',
    },
    imageClass: 'cian-pin',
  },
  host: {
    title: `Размещайтесь на${NBSP}Циан.Посуточно`,
    linkBtn: {
      url: PLACE_ON_CIAN_LINK,
      text: 'Разместить объявление',
    },
    imageClass: 'cian-calendar',
  },
};
